import firebase from "firebase/compat/app";
import { initializeApp, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";

const clientCredentials = {
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
};

if (!firebase.apps.length) {
  initializeApp(clientCredentials);
}

const firebaseAuth = getAuth();
const firestore = getFirestore();
const functions = getFunctions(getApp(), "asia-northeast3");

export { firestore, firebaseAuth, functions };
